<div>
  <h6 class="odx-title-6" i18n="@@global.itRooms">IT rooms</h6>

  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      class="it-room"
      (click)="addItRoom()"
      [odxTooltip]="tooltipText"
      [odxTooltipOptions]="{ position: 'bottom-start' }"
      draggable="true"
      (dragstart)="dragItRoom()"
    >
      <odx-icon name="plus" size="medium"></odx-icon>
    </button>
    <app-toggle-visibility-button
      [visible]="floorplanState.itRoomsVisible"
      (toggleEvent)="floorplanState.itRoomsVisible = $event"
    >
    </app-toggle-visibility-button>

    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.itRoomsItemTextVisible"
      (toggleEvent)="updateItRoomsItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button [locked]="floorplanState.itRoomsLocked" (toggleEvent)="floorplanState.itRoomsLocked = $event">
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
